@if(visualUpliftEnabled()) {
  <div 
    class="shared-list-max-width hmf-subtle-shadow card" 
    [class.hmf-my-m]="!isPublicList()"
    [class.hmf-m-m]="isPublicList()">
    <div class="card-content hmf-py-xl">
      <homefield-icon width="52px" height="52px" name="reaction-love-empty-fill" fill="var(--hmf-label-disabled)" />
      <p class="hmf-header-bold-l hmf-mt-m">{{ getListSubheadText() }}</p>
      <p class="hmf-body-l hmf-mb-0">{{ listPromptText() }}</p>
      <p class="hmf-body-l hmf-mb-m">{{ listSubPromptText() }}</p>

      @if (!isAuthenticated()) {
        <div class="hmf-grid hmf-justify-content-center">
          <hmf-button 
            [variant]="'marketing'" 
            [text]="'Sign In'"
            [classList]="'hmf-col hmf-mx-m hmf-mb-s hmf-mb-m-0 hmf-mr-m-xxs hmf-span-12 hmf-span-m-3'" 
            (click)="signIn()"
            (keydown.enter)="signIn()">
          </hmf-button>
          <hmf-button 
            [variant]="'secondary'" 
            [text]="'Create Account'"
            [classList]="'hmf-col hmf-mx-m hmf-ml-m-xxs hmf-span-12 hmf-span-m-3'" 
            (click)="createAccount()"
            (keydown.enter)="createAccount()">
          </hmf-button>
        </div>
      } @else {
        <hmf-button
					[variant]="'primary'"
					[text]="`Shop ${shopButtonText()}`"
					[classList]="'hmf-flex-grow hmf-mb-s hmf-span-3'"
					(click)="navigateToSeeWhatsNewPage()"
					(keydown.enter)="navigateToSeeWhatsNewPage()">
				</hmf-button>
      }
    </div>
  </div>
} @else {
  <div class="hmf-grid hmf-mt-xs hmf-mx-0 top-padding">
    <div class="hmf-col hmf-span-12 hmf-px-s-0 hmf-text-align-center">
      <img src="assets/image/empty_favorites.svg" class="reactionLoveFilledIcon" alt="empty favorites Icon">
      <p class="hmf-header-bold-l">{{ getListSubheadText() }}</p>
      @if (!isPublicList()) {
        <p class="hmf-body-m">Explore gear and add to your favorites anywhere you see a heart.</p>
      } @else {
        <p class="hmf-body-m hmf-mb-xxl">Reach out to the list owner and ask them<br>to start adding their favorite
        gear!</p>
      }
    </div>
  </div>
}

@if (!isPublicList()) {
<!-- This looks like it is probably meant to be shared-favorites-components-shop-by-category now -->
<myaccount-shop-by-category></myaccount-shop-by-category>
}
